import { render, staticRenderFns } from "./important_warn_article.vue?vue&type=template&id=6a479d18&scoped=true"
import script from "./important_warn_article.vue?vue&type=script&lang=ts"
export * from "./important_warn_article.vue?vue&type=script&lang=ts"
import style0 from "./important_warn_article.vue?vue&type=style&index=0&id=6a479d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a479d18",
  null
  
)

export default component.exports